export const PersonIdTyp = {
    PERSONNUMMER: "1.2.752.129.2.1.3.1",
    SAMORDNINGSNUMMER: "1.2.752.129.2.1.3.3",
    SSLRESORVNUMMER: "1.2.752.97.3.1.3",
};

export const Roller = {
    OPERATIONSKOORDINATOR: "operationskoordinator",
    KIRURG: "kirurg",
};

export const Avtalstyper = {
    FORSAKRING: "Försäkring",
};
